var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 665,
    zoomAndPan: "magnify",
    viewBox: "0 0 498.75 149.999998",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ac99091126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36 8 L 92 8 L 92 46 L 36 46 Z M 36 8 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "94669cd551"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 91.488281 29 C 87.820312 34.066406 85.039062 39.835938 83.292969 45.941406 C 79.449219 37.027344 72.644531 29.53125 64.097656 25.152344 C 55.546875 29.511719 48.566406 37.027344 44.898438 45.941406 C 43.152344 39.835938 40.195312 34.066406 36.703125 29 C 38.800781 26.039062 41.410156 23.074219 44.039062 20.621094 C 49.804688 15.203125 56.585938 11.023438 64.273438 8.214844 C 71.785156 10.824219 78.742188 15.203125 84.507812 20.621094 C 86.960938 23.074219 89.414062 26.039062 91.488281 29 Z M 91.488281 29 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 465.26599,
    gradientTransform: "matrix(0.22091, 0, 0, -0.221153, -38.670756, 313.497289)",
    y1: 1209.822776,
    x2: 465.26599,
    gradientUnits: "userSpaceOnUse",
    y2: 1380.422773,
    id: "dbe9d0db6a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.756287%, 74.116516%, 27.059937%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.553345%, 73.999023%, 27.082825%)",
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.350403%, 73.881531%, 27.105713%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.147461%, 73.762512%, 27.128601%)",
    offset: 0.0117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.946045%, 73.64502%, 27.151489%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.743103%, 73.526001%, 27.174377%)",
    offset: 0.0195313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.541687%, 73.408508%, 27.197266%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.338745%, 73.291016%, 27.220154%)",
    offset: 0.0273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.137329%, 73.173523%, 27.243042%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.934387%, 73.054504%, 27.26593%)",
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.732971%, 72.937012%, 27.288818%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.530029%, 72.817993%, 27.311707%)",
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.328613%, 72.7005%, 27.336121%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.125671%, 72.583008%, 27.359009%)",
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.924255%, 72.465515%, 27.381897%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.721313%, 72.346497%, 27.404785%)",
    offset: 0.0585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.519897%, 72.229004%, 27.427673%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.316956%, 72.109985%, 27.450562%)",
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.11554%, 71.992493%, 27.47345%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.912598%, 71.875%, 27.496338%)",
    offset: 0.0742187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.711182%, 71.757507%, 27.519226%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.50824%, 71.638489%, 27.542114%)",
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.305298%, 71.520996%, 27.565002%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.102356%, 71.401978%, 27.587891%)",
    offset: 0.0898437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.90094%, 71.284485%, 27.610779%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.697998%, 71.166992%, 27.633667%)",
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.496582%, 71.0495%, 27.656555%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.29364%, 70.930481%, 27.679443%)",
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.092224%, 70.812988%, 27.702332%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.889282%, 70.69397%, 27.72522%)",
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.687866%, 70.576477%, 27.749634%)",
    offset: 0.117187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.484924%, 70.458984%, 27.772522%)",
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.283508%, 70.341492%, 27.79541%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.080566%, 70.222473%, 27.818298%)",
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.87915%, 70.10498%, 27.841187%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.676208%, 69.985962%, 27.864075%)",
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.474792%, 69.868469%, 27.886963%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.271851%, 69.750977%, 27.909851%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.070435%, 69.633484%, 27.932739%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.867493%, 69.514465%, 27.955627%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.666077%, 69.396973%, 27.978516%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.463135%, 69.277954%, 28.001404%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.260193%, 69.160461%, 28.024292%)",
    offset: 0.164063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.057251%, 69.042969%, 28.04718%)",
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.855835%, 68.925476%, 28.070068%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.652893%, 68.806458%, 28.092957%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.451477%, 68.688965%, 28.115845%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.248535%, 68.569946%, 28.138733%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.047119%, 68.452454%, 28.163147%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.844177%, 68.334961%, 28.186035%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.642761%, 68.217468%, 28.208923%)",
    offset: 0.195313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.439819%, 68.09845%, 28.231812%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.238403%, 67.980957%, 28.2547%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.035461%, 67.861938%, 28.277588%)",
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.834045%, 67.744446%, 28.300476%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.631104%, 67.625427%, 28.323364%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.429688%, 67.507935%, 28.346252%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.226746%, 67.390442%, 28.369141%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.02533%, 67.272949%, 28.392029%)",
    offset: 0.226563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.822388%, 67.153931%, 28.414917%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.620972%, 67.036438%, 28.437805%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.41803%, 66.917419%, 28.460693%)",
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.215088%, 66.799927%, 28.483582%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.012146%, 66.682434%, 28.50647%)",
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.81073%, 66.564941%, 28.530884%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.607788%, 66.445923%, 28.553772%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.406372%, 66.32843%, 28.57666%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.20343%, 66.209412%, 28.599548%)",
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.002014%, 66.091919%, 28.622437%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.799072%, 65.974426%, 28.645325%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.597656%, 65.856934%, 28.668213%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.394714%, 65.737915%, 28.691101%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.193298%, 65.620422%, 28.713989%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.990356%, 65.501404%, 28.736877%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.78894%, 65.383911%, 28.759766%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.585999%, 65.266418%, 28.782654%)",
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.384583%, 65.148926%, 28.805542%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.181641%, 65.029907%, 28.82843%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.980225%, 64.912415%, 28.851318%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.777283%, 64.793396%, 28.874207%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.575867%, 64.675903%, 28.897095%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.372925%, 64.558411%, 28.919983%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.169983%, 64.440918%, 28.944397%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.967041%, 64.321899%, 28.967285%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.765625%, 64.204407%, 28.990173%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.562683%, 64.085388%, 29.013062%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.361267%, 63.967896%, 29.03595%)",
    offset: 0.335937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.158325%, 63.850403%, 29.058838%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.956909%, 63.73291%, 29.081726%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.753967%, 63.613892%, 29.104614%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.552551%, 63.496399%, 29.127502%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.349609%, 63.37738%, 29.150391%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.148193%, 63.259888%, 29.173279%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.945251%, 63.142395%, 29.196167%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.743835%, 63.024902%, 29.219055%)",
    offset: 0.367187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.540894%, 62.905884%, 29.241943%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.339478%, 62.788391%, 29.264832%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.136536%, 62.669373%, 29.28772%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.93512%, 62.55188%, 29.310608%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.732178%, 62.434387%, 29.333496%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.530762%, 62.316895%, 29.35791%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.32782%, 62.197876%, 29.380798%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.124878%, 62.080383%, 29.403687%)",
    offset: 0.398437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.921936%, 61.961365%, 29.426575%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.72052%, 61.843872%, 29.449463%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.517578%, 61.726379%, 29.472351%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.316162%, 61.608887%, 29.495239%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.11322%, 61.489868%, 29.518127%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.911804%, 61.372375%, 29.541016%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.708862%, 61.253357%, 29.563904%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.507446%, 61.135864%, 29.586792%)",
    offset: 0.429687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.304504%, 61.018372%, 29.60968%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.103088%, 60.900879%, 29.632568%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.900146%, 60.78186%, 29.655457%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.69873%, 60.664368%, 29.678345%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.495789%, 60.545349%, 29.701233%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.294373%, 60.427856%, 29.725647%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.091431%, 60.310364%, 29.748535%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.890015%, 60.192871%, 29.771423%)",
    offset: 0.460937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.687073%, 60.073853%, 29.794312%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.485657%, 59.95636%, 29.8172%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.282715%, 59.837341%, 29.840088%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.079773%, 59.719849%, 29.862976%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.876831%, 59.60083%, 29.885864%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.675415%, 59.483337%, 29.908752%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.472473%, 59.365845%, 29.931641%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.271057%, 59.248352%, 29.954529%)",
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.068115%, 59.129333%, 29.977417%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.866699%, 59.011841%, 30.000305%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.663757%, 58.892822%, 30.023193%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.462341%, 58.77533%, 30.046082%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.259399%, 58.657837%, 30.06897%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.057983%, 58.540344%, 30.091858%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.855042%, 58.421326%, 30.114746%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.653625%, 58.303833%, 30.13916%)",
    offset: 0.523437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.450684%, 58.184814%, 30.162048%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.249268%, 58.067322%, 30.184937%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.046326%, 57.949829%, 30.207825%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.84491%, 57.832336%, 30.230713%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.641968%, 57.713318%, 30.253601%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.440552%, 57.595825%, 30.276489%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.23761%, 57.476807%, 30.299377%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.034668%, 57.359314%, 30.322266%)",
    offset: 0.554687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.831726%, 57.241821%, 30.345154%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.63031%, 57.124329%, 30.368042%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.427368%, 57.00531%, 30.39093%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.225952%, 56.887817%, 30.413818%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.02301%, 56.768799%, 30.436707%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.821594%, 56.651306%, 30.459595%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.618652%, 56.533813%, 30.482483%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.417236%, 56.416321%, 30.505371%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.214294%, 56.297302%, 30.528259%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.012878%, 56.17981%, 30.552673%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.809937%, 56.060791%, 30.575562%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.608521%, 55.943298%, 30.59845%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.405579%, 55.825806%, 30.621338%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.204163%, 55.708313%, 30.644226%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.001221%, 55.589294%, 30.667114%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.799805%, 55.471802%, 30.690002%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.596863%, 55.352783%, 30.712891%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.393921%, 55.235291%, 30.735779%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.190979%, 55.117798%, 30.758667%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.989563%, 55.000305%, 30.781555%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.786621%, 54.881287%, 30.804443%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.585205%, 54.763794%, 30.827332%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.382263%, 54.644775%, 30.85022%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.180847%, 54.527283%, 30.873108%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.977905%, 54.40979%, 30.895996%)",
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.776489%, 54.292297%, 30.92041%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.573547%, 54.173279%, 30.943298%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.372131%, 54.055786%, 30.966187%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.169189%, 53.936768%, 30.989075%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.967773%, 53.819275%, 31.011963%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.764832%, 53.701782%, 31.034851%)",
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.563416%, 53.58429%, 31.057739%)",
    offset: 0.679687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.360474%, 53.465271%, 31.080627%)",
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.159058%, 53.347778%, 31.103516%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.956116%, 53.22876%, 31.126404%)",
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.7547%, 53.111267%, 31.149292%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.551758%, 52.993774%, 31.17218%)",
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.348816%, 52.876282%, 31.195068%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.145874%, 52.757263%, 31.217957%)",
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.944458%, 52.639771%, 31.240845%)",
    offset: 0.710937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.741516%, 52.520752%, 31.263733%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.5401%, 52.403259%, 31.286621%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.337158%, 52.284241%, 31.309509%)",
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.135742%, 52.166748%, 31.333923%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.9328%, 52.049255%, 31.356812%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.731384%, 51.931763%, 31.3797%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.528442%, 51.812744%, 31.402588%)",
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.327026%, 51.695251%, 31.425476%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.124084%, 51.576233%, 31.448364%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.922668%, 51.45874%, 31.471252%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.719727%, 51.341248%, 31.494141%)",
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.518311%, 51.223755%, 31.517029%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.315369%, 51.104736%, 31.539917%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.113953%, 50.987244%, 31.562805%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.911011%, 50.868225%, 31.585693%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.709595%, 50.750732%, 31.608582%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.506653%, 50.63324%, 31.63147%)",
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.303711%, 50.515747%, 31.654358%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.100769%, 50.396729%, 31.677246%)",
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.899353%, 50.279236%, 31.70166%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.696411%, 50.160217%, 31.724548%)",
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.494995%, 50.042725%, 31.747437%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.292053%, 49.925232%, 31.770325%)",
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.090637%, 49.807739%, 31.793213%)",
    offset: 0.804687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.887695%, 49.688721%, 31.816101%)",
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.686279%, 49.571228%, 31.838989%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.483337%, 49.452209%, 31.861877%)",
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.281921%, 49.334717%, 31.884766%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.078979%, 49.217224%, 31.907654%)",
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.877563%, 49.099731%, 31.930542%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.674622%, 48.980713%, 31.95343%)",
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.473206%, 48.86322%, 31.976318%)",
    offset: 0.835937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.270264%, 48.744202%, 31.999207%)",
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.068848%, 48.626709%, 32.022095%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.865906%, 48.509216%, 32.044983%)",
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.66449%, 48.391724%, 32.067871%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.461548%, 48.272705%, 32.090759%)",
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.258606%, 48.155212%, 32.115173%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.055664%, 48.036194%, 32.138062%)",
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.854248%, 47.918701%, 32.16095%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.651306%, 47.801208%, 32.183838%)",
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.44989%, 47.683716%, 32.206726%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.246948%, 47.564697%, 32.229614%)",
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.045532%, 47.447205%, 32.252502%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.84259%, 47.328186%, 32.275391%)",
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.641174%, 47.210693%, 32.298279%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.438232%, 47.093201%, 32.321167%)",
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.236816%, 46.975708%, 32.344055%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.033875%, 46.856689%, 32.366943%)",
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.832458%, 46.739197%, 32.389832%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.629517%, 46.620178%, 32.41272%)",
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.428101%, 46.502686%, 32.435608%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.225159%, 46.385193%, 32.458496%)",
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.023743%, 46.2677%, 32.481384%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.820801%, 46.148682%, 32.504272%)",
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.619385%, 46.031189%, 32.528687%)",
    offset: 0.929687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.416443%, 45.91217%, 32.551575%)",
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.213501%, 45.794678%, 32.574463%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.010559%, 45.677185%, 32.597351%)",
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.809143%, 45.559692%, 32.620239%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.606201%, 45.440674%, 32.643127%)",
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.404785%, 45.323181%, 32.666016%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.201843%, 45.204163%, 32.688904%)",
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.000427%, 45.08667%, 32.711792%)",
    offset: 0.960937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.797485%, 44.969177%, 32.73468%)",
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.596069%, 44.851685%, 32.757568%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.393127%, 44.732666%, 32.780457%)",
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.191711%, 44.615173%, 32.803345%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.98877%, 44.496155%, 32.826233%)",
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.787354%, 44.378662%, 32.849121%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.584412%, 44.259644%, 32.872009%)",
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.382996%, 44.142151%, 32.896423%)",
    offset: 0.992187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.190735%, 44.030762%, 32.917786%)",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ac99091126)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#94669cd551)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dbe9d0db6a)",
    d: "M 36.703125 45.941406 L 36.703125 8.214844 L 91.488281 8.214844 L 91.488281 45.941406 Z M 36.703125 45.941406 ",
    fillRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#004432",
    d: "M 3.414062 98.15625 C 3.941406 94.484375 3.941406 90.8125 3.414062 87.164062 C 9.6875 93.089844 23.824219 95.898438 35.863281 95.898438 C 45.804688 95.898438 49.824219 93.621094 49.824219 89.265625 C 49.824219 83.492188 43.550781 82.808594 28.90625 81.589844 C 12.691406 80.199219 2.925781 77.566406 2.925781 67.613281 C 2.925781 57.664062 11.652344 52.953125 29.789062 52.953125 C 42.335938 52.953125 50.023438 54.699219 59.257812 56.976562 C 58.726562 60.472656 58.726562 63.964844 59.257812 67.28125 C 51.59375 64.140625 41.476562 60.824219 29.4375 60.824219 C 19.316406 60.824219 14.964844 62.925781 14.964844 67.28125 C 14.964844 72.523438 20.203125 73.917969 33.808594 74.957031 C 50.90625 76.351562 62.0625 78.628906 62.0625 89.265625 C 62.0625 99.039062 52.984375 103.75 35.203125 103.75 C 22.765625 103.90625 11.785156 101.296875 3.414062 98.15625 Z M 3.414062 98.15625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#004432",
    d: "M 82.253906 63.058594 C 82.078125 76.328125 82.253906 89.949219 82.785156 103.21875 L 71.097656 103.21875 C 71.628906 86.8125 71.628906 70.222656 71.097656 53.816406 C 75.453125 54.34375 83.140625 54.523438 87.492188 53.816406 C 97.609375 67.613281 108.410156 81.0625 119.414062 94.328125 C 119.589844 80.882812 119.414062 67.261719 118.882812 53.816406 C 123.058594 54.34375 126.902344 54.523438 130.746094 53.816406 C 130.214844 70.222656 130.390625 86.8125 130.921875 103.21875 L 114.707031 103.21875 C 104.414062 89.597656 93.589844 76.152344 82.253906 63.058594 Z M 82.253906 63.058594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#004432",
    d: "M 142.078125 53.636719 C 150.980469 53.636719 159.351562 53.460938 171.902344 53.460938 C 187.605469 53.460938 195.980469 57.132812 195.980469 65.867188 C 195.980469 73.71875 189 76.703125 180.449219 77.035156 L 180.449219 77.898438 C 191.097656 78.253906 198.941406 81.746094 198.941406 90.128906 C 198.941406 102.003906 182.546875 103.574219 170.683594 103.574219 C 156.902344 103.574219 150.980469 103.21875 141.722656 103.21875 C 142.785156 90.8125 142.785156 66.023438 142.078125 53.636719 Z M 172.078125 75.445312 C 180.273438 75.445312 184.117188 72.988281 184.117188 68.101562 C 184.117188 62.859375 179.765625 61.113281 172.078125 61.113281 C 164.058594 61.113281 157.609375 61.113281 153.941406 61.113281 C 153.765625 65.46875 153.765625 70.203125 153.765625 75.265625 C 159.351562 75.445312 165.625 75.445312 172.078125 75.445312 Z M 153.941406 95.523438 C 159.175781 95.699219 163.175781 95.878906 171.546875 95.878906 C 183.410156 95.878906 186.371094 92.382812 186.371094 88.535156 C 186.371094 85.042969 183.410156 82.078125 171.902344 82.078125 C 165.449219 82.078125 159.175781 82.078125 153.585938 82.078125 C 153.585938 86.457031 153.765625 91.34375 153.941406 95.523438 Z M 153.941406 95.523438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#004432",
    d: "M 215.683594 78.253906 C 215.683594 61.84375 228.761719 52.753906 250.035156 52.753906 C 257.703125 52.753906 266.25 53.792969 276.898438 58.347656 C 276.546875 61.136719 276.546875 63.414062 276.898438 66.199219 C 266.25 60.273438 257.371094 58.855469 250.390625 58.679688 C 234.351562 58.679688 224.058594 65.667969 224.058594 78.230469 C 224.058594 90.28125 232.960938 98.132812 250.035156 98.132812 C 259.269531 98.132812 268.351562 95.855469 276.898438 88.183594 C 276.546875 90.96875 277.074219 93.777344 277.429688 95.855469 C 270.09375 101.273438 261.722656 104.0625 249.351562 104.0625 C 227.902344 104.082031 215.683594 94.308594 215.683594 78.253906 Z M 215.683594 78.253906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#004432",
    d: "M 318.9375 103.042969 C 317.898438 100.078125 317.371094 97.117188 317.191406 94.308594 C 313.347656 99.726562 307.605469 103.90625 297.839844 103.90625 C 288.253906 103.90625 283.878906 99.726562 283.878906 94.128906 C 283.878906 87.496094 290.507812 83.648438 303.761719 83.648438 L 317.191406 83.648438 C 316.839844 76.484375 314.917969 71.949219 303.585938 71.949219 C 295.742188 71.949219 288.761719 74.558594 284.917969 78.054688 C 285.269531 76.128906 285.269531 72.8125 284.917969 71.066406 C 289.625 68.609375 296.25 66.53125 304.625 66.53125 C 317.699219 66.53125 324.328125 70.710938 324.503906 82.585938 C 324.503906 90.792969 324.859375 96.5625 326.957031 103.019531 Z M 317.015625 93.089844 C 317.015625 90.8125 317.015625 88.734375 317.015625 86.988281 L 317.015625 86.125 L 308.644531 86.125 C 298.347656 86.125 292.074219 87.695312 292.074219 92.757812 C 292.074219 96.785156 295.566406 98.863281 301.484375 98.863281 C 308.113281 98.839844 313.347656 96.410156 317.015625 93.089844 Z M 317.015625 93.089844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#004432",
    d: "M 377.191406 84.53125 C 377.191406 95.878906 369.527344 104.082031 356.78125 104.082031 C 350.859375 104.082031 344.742188 101.472656 341.78125 96.5625 C 341.78125 103.199219 341.957031 109.832031 342.488281 116.46875 C 339.171875 116.113281 336.390625 116.113281 333.585938 116.46875 C 334.621094 108.261719 334.621094 83.292969 333.585938 68.277344 C 336.722656 68.101562 340.386719 67.570312 342.488281 66.707031 C 341.625 71.773438 341.273438 75.953125 341.09375 79.800781 L 341.800781 79.800781 C 344.410156 72.8125 350.351562 66.53125 359.9375 66.53125 C 370.035156 66.554688 377.191406 73.875 377.191406 84.53125 Z M 369.347656 84.886719 C 369.347656 77.210938 364.46875 71.972656 356.273438 71.972656 C 343.722656 71.972656 341.800781 82.960938 341.800781 89.441406 L 341.800781 93.976562 C 345.292969 98.332031 349.996094 99.75 354.351562 99.75 C 362.546875 99.726562 369.347656 94.660156 369.347656 84.886719 Z M 369.347656 84.886719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#004432",
    d: "M 382.25 57.285156 C 382.25 54.832031 384.171875 53.4375 387.664062 53.4375 C 391.507812 53.4375 393.582031 54.65625 393.582031 57.285156 C 393.582031 59.917969 391.660156 61.136719 387.664062 61.136719 C 384.171875 61.136719 382.25 59.917969 382.25 57.285156 Z M 392.015625 67.59375 C 391.484375 79.644531 391.484375 91.167969 392.015625 103.21875 L 383.640625 103.21875 C 384.171875 91.167969 384.171875 79.644531 383.640625 67.59375 C 386.601562 67.945312 389.054688 68.125 392.015625 67.59375 Z M 392.015625 67.59375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#004432",
    d: "M 413.289062 87.496094 C 413.113281 95.523438 417.308594 97.980469 422.367188 98.15625 C 425.859375 98.332031 429.878906 97.292969 433.015625 96.054688 C 432.664062 97.980469 432.664062 99.902344 433.015625 101.828125 C 429.527344 102.867188 424.996094 104.105469 420.46875 103.929688 C 413.132812 103.75 406.328125 100.789062 406.328125 90.835938 C 406.328125 88.378906 406.328125 80.53125 406.152344 72.324219 C 402.839844 72.324219 399.527344 72.503906 396.210938 72.679688 C 396.390625 71.285156 396.390625 68.832031 396.210938 67.4375 C 399.347656 67.613281 402.664062 67.792969 405.976562 67.792969 C 405.976562 63.613281 405.621094 59.410156 405.445312 56.445312 C 408.582031 56.09375 411.367188 55.738281 413.820312 54.699219 C 413.820312 59.054688 413.640625 63.433594 413.464844 67.792969 C 420.09375 67.792969 426.898438 67.613281 432.816406 67.261719 C 432.640625 69.183594 432.640625 70.578125 432.816406 72.503906 C 426.71875 72.148438 419.914062 71.972656 413.289062 71.972656 C 413.289062 77.542969 413.289062 82.785156 413.289062 87.496094 Z M 413.289062 87.496094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#004432",
    d: "M 472.074219 103.042969 C 471.035156 100.078125 470.503906 97.117188 470.328125 94.308594 C 466.484375 99.726562 460.738281 103.90625 450.976562 103.90625 C 441.386719 103.90625 437.015625 99.726562 437.015625 94.128906 C 437.015625 87.496094 443.640625 83.648438 456.894531 83.648438 L 470.328125 83.648438 C 469.972656 76.484375 468.050781 71.949219 456.71875 71.949219 C 448.878906 71.949219 441.894531 74.558594 438.050781 78.054688 C 438.40625 76.128906 438.40625 72.8125 438.050781 71.066406 C 442.757812 68.609375 449.386719 66.53125 457.757812 66.53125 C 470.835938 66.53125 477.460938 70.710938 477.640625 82.585938 C 477.640625 90.792969 477.992188 96.5625 480.089844 103.019531 Z M 470.152344 93.089844 C 470.152344 90.8125 470.152344 88.734375 470.152344 86.988281 L 470.152344 86.125 L 461.777344 86.125 C 451.484375 86.125 445.210938 87.695312 445.210938 92.757812 C 445.210938 96.785156 448.699219 98.863281 454.621094 98.863281 C 461.445312 98.839844 466.503906 96.410156 470.152344 93.089844 Z M 470.152344 93.089844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#004432",
    d: "M 494.761719 50.320312 C 493.722656 63.945312 493.898438 88.378906 494.40625 103.042969 L 486.035156 103.042969 C 486.742188 89.242188 486.894531 65.160156 486.035156 51.714844 C 489.171875 51.714844 491.953125 51.359375 494.761719 50.320312 Z M 494.761719 50.320312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLogo);
export default __webpack_public_path__ + "static/media/green-logo.11aa13c57ce9c4d3dd50b8d7442a0fc9.svg";
export { ForwardRef as ReactComponent };